import { CustomColumn } from '../../types/customColumn';

export interface CashRegisterSummary {
  id: number;
  name: string;
  code: string;
  branchName: string;
  active: boolean;
}

export const cashRegisterColumns: CustomColumn<CashRegisterSummary>[] = [
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ row }) => (
      <div className="text-sm font-medium text-black dark:text-white">
        {row.original.branchName}
      </div>
    ),
  },

  {
    Header: 'Código',
    accessor: 'code',
    customCell: ({ row }) => (
      <span className="text-sm font-semibold text-primary">
        {row.original.code}
      </span>
    ),
  },

  {
    Header: 'Nombre',
    accessor: 'name',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.name}
      </span>
    ),
  },

  {
    Header: 'Estado',
    accessor: 'active',
    customCell: ({ row }) => {
      const active = row.original.active;

      return (
        <span
          className={`rounded-full px-2 py-1 text-xs font-semibold ${
            active ? 'bg-success text-white' : 'bg-danger text-white'
          }`}
        >
          {active ? 'Activa' : 'Inactiva'}
        </span>
      );
    },
  },
];
